module.exports = __webpack_public_path__ + "img/alba-3.dc070947.png";